import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { LoginService } from '../../core/services/login.service';
import { LoggerService } from '../../core/services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class AuthResolver implements Resolve<boolean> {
  constructor(
    private loginService: LoginService,
    private logger: LoggerService,
    private router: Router,
  ) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    const { authService, centralId, authMode } = route.data;

    /*this.logger.info(
      `AuthResolver - Iniciando autenticação: Serviço=${authService}, CentralID=${centralId}, AuthMode=${authMode}`,
    );*/

    try {
      const isAuthenticated = await this.loginService.login(
        authService,
        centralId,
        false,
        authMode,
        true,
      );
      /*if (!isAuthenticated) {
        this.logger.warn('AuthResolver - Usuário não autenticado');
      }*/
      return isAuthenticated;
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
}
